import { CHF } from 'lib/utilities'
import React from 'react'
import { Table } from 'semantic-ui-react'

export default class CustomerFooter extends React.PureComponent {
  render() {
    const { data } = this.props
    console.log(data)
    return (
      <Table.Footer>
        <Table.Row>
          <Table.Cell colSpan="4" textAlign="right">
            Summe Produkte
          </Table.Cell>
          <Table.Cell textAlign="right">
            <strong>{CHF(data.product_sum)}</strong>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell colSpan="4" textAlign="right">
            Versandkosten
          </Table.Cell>
          <Table.Cell textAlign="right">{CHF(data.shipping)}</Table.Cell>
        </Table.Row>
        {!!data.user_discount_amount && (
          <Table.Row>
            <Table.Cell colSpan="4" textAlign="right">
              Selbstabholerrabatt
            </Table.Cell>
            <Table.Cell textAlign="right">
              {CHF(-data.user_discount_amount)}
            </Table.Cell>
          </Table.Row>
        )}
        {!!data.discount_code_amount && (
          <Table.Row>
            <Table.Cell
              colSpan="4"
              textAlign="right"
              children={
                (data.discount_code.kind === 'credit'
                  ? 'Gutschein '
                  : 'BOP-Code ') +
                data.discount_code_code +
                (data.discount_code_percent
                  ? `(${data.discount_code_percent}%)`
                  : '')
              }
            />
            <Table.Cell textAlign="right">
              {CHF(-data.discount_code_amount)}
            </Table.Cell>
          </Table.Row>
        )}
        <Table.Row>
          <Table.Cell colSpan="4" textAlign="right">
            Summe Netto
          </Table.Cell>
          <Table.Cell textAlign="right">{CHF(data.total_sum)}</Table.Cell>
        </Table.Row>
        <Table.Row className="unobtrusive">
          <Table.Cell colSpan={4} textAlign="right">
            MwSt.
          </Table.Cell>
          <Table.Cell textAlign="right">
            <strong>{CHF(data.total_vat)}</strong>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell colSpan={4} textAlign="right">
            <strong>Total</strong>
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            <strong>{CHF(data.total_sum_incl_vat)}</strong>
          </Table.HeaderCell>
        </Table.Row>
        {data.dealer_id > 1 && (
          <Table.Row className="unobtrusive">
            <Table.Cell colSpan="4" textAlign="right">
              Errechnete Marge des Händlers
            </Table.Cell>
            <Table.Cell textAlign="right">
              {100 -
                ((data.bop_sum + data.bop_surcharge) / data.product_sum) * 100}
              %
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Carts/CustomerCart/CustomerFooter.jsx